const open = document.querySelector('.icon-info');
const modal = document.querySelector('.product__price-modal');

if (open && modal) {
  open.addEventListener('mouseover', () => {
    modal.classList.add('open');
  });
  modal.addEventListener('mouseout', () => {
    modal.classList.remove('open');
  });
}
